import { render, staticRenderFns } from "./PayrollWrapper.vue?vue&type=template&id=041c0c68&scoped=true"
import script from "./PayrollWrapper.vue?vue&type=script&lang=js"
export * from "./PayrollWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041c0c68",
  null
  
)

export default component.exports